import { IntlShape } from 'react-intl';

import { CUSTOM_LESSON_INFO_LANDING_LINK_ID as landingLinkId } from './constants';

export const getInfoLandingLink = (intl: IntlShape) => {
    const link = intl.formatMessage({ id: landingLinkId });
    return link === landingLinkId ? '' : link;
};
